// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/trending-up.js';

import { paths } from '../generated/trending-up';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('trending-up', Original, paths);
